import React, { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Store, Dispatcher, Constants } from "../../../flux";

const ThemeToggle = () => {
  const { t } = useTranslation();
  const [theme, setTheme] = useState(Store.getTheme());

  useEffect(() => {
    const onChange = () => setTheme(Store.getTheme());
    Store.addChangeListener(onChange);
    return () => Store.removeChangeListener(onChange);
  }, []);

  const isDark = theme === "dark";

  const handleClick = () => {
    Dispatcher.dispatch({ actionType: Constants.TOGGLE_THEME });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="nav-link smartfarm-theme-toggle"
      aria-pressed={isDark}
      aria-label={
        isDark
          ? t("theme_toggle_to_light", { defaultValue: "Switch to light mode" })
          : t("theme_toggle_to_dark", { defaultValue: "Switch to dark mode" })
      }
      title={
        isDark
          ? t("theme_toggle_to_light", { defaultValue: "Switch to light mode" })
          : t("theme_toggle_to_dark", { defaultValue: "Switch to dark mode" })
      }
    >
      {isDark ? (
        <Sun className="smartfarm-theme-toggle-icon" aria-hidden="true" />
      ) : (
        <Moon className="smartfarm-theme-toggle-icon" aria-hidden="true" />
      )}
    </button>
  );
};

export default ThemeToggle;
